import { Event } from "@/types/event/event";

export async function getEventDetails(uuid: string): Promise<Event> {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/events/event/${uuid}`);
    if (!response.ok) {
        throw new Error("Failed to fetch event details");
    }
    return response.json();
}